import { forwardRef } from "react";
import { observer } from "mobx-react";
import { getDateKey } from "@repo/structure";
import { useEstimateTableSettings } from "@tools";
import { Grid } from "@material-ui/core";
import { TimelineExpandingMonth } from "./components/TimelineExpandingMonth";

export const TimelineGrid = observer(forwardRef((_, ref) => {
  const { timelineMonths } = useEstimateTableSettings();

  return (
    <Grid item container wrap="nowrap" ref={ref} className="h-full w-max">
      {timelineMonths.map((month, monthIndex) => (
        <TimelineExpandingMonth
          key={getDateKey(month.startDate)}
          month={month}
          monthIndex={monthIndex}
        />
      ))}
    </Grid>
  );
}));

TimelineGrid.displayName = "TimelineGrid";
